import { Navigate, useParams } from 'react-router-dom';

import { useGetUbicacion } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveUbicaciones } from '../../shared/saveUbicaciones';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';

export interface UpdateUbicacionesPageInterface {}

const UpdateUbicacionesPage: React.FC<UpdateUbicacionesPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_ubicacion);
  const { id } = useParams();
  const { data, isLoading } = useGetUbicacion(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_ubicacion) return <Navigate to="/inventario/ubicaciones" />;

  return <SaveUbicaciones titlePage="Editar Ubicaciones del producto" editUbicaciones={data.data} />;
};

export default UpdateUbicacionesPage;
